export interface IWorkerCustomField {
  fieldId: string;
  name: string;
  code: string;
  section: string;
  dataType: number;
  isVisibleByDefault: boolean;
  isVisible: boolean;
  isMandatoryByDefault: boolean;
  isMandatory: boolean;
  isSkippableByDefault: boolean;
  isSkippable: boolean;
  skippableTill: number;
  canOverrideVisibleByDefault: boolean;
  canOverrideMandatoryByDefault: boolean;
  canOverrideSkippableByDefault: boolean;
  entityType: number;
}

export interface IProfileFieldConstraints {
  isVisible: boolean;
  isMandatory: boolean;
  isSkippable: boolean;
  skippableTill: number;
}

export enum WorkerProfileField {
  email = 'WorkerContactEmail',
  mobilePhoneNumber = 'WorkerContactMobileNumber',
  emailOrMobilePhoneNumber = 'WorkerContactEmailOrMobilePhone',

  workerProfilePhoto = 'WorkerProfilePhoto',

  alternateContactMobilePhoneNumber = 'WorkerContactAlternateMobileNumber',

  homeAddressLine1 = 'WorkerHomeAddressLine1',
  homeAddressLine2 = 'WorkerHomeAddressLine2',
  homeAddressCountry = 'WorkerHomeAddressCountry',
  homeAddressStateProvince = 'WorkerHomeAddressStateProvince',
  homeAddressCity = 'WorkerHomeAddressCity',
  homeAddressZipPostal = 'WorkerHomeAddressZipPostal',
  emergencyContactName = 'WorkerEmergencyContactName',
  emergencyContactRelationship = 'WorkerEmergencyContactRelationship',
  emergencyContactMobilePhone = 'WorkerEmergencyContactMobilePhone',
  workerFirstName = 'WorkerFirstName',
  workerMiddleName = 'WorkerMiddleName',
  workerLastName = 'WorkerLastName',
  workerDateOfBirth = 'WorkerDateOfBirth',
  workerGender = 'WorkerGender',
  workerEthnicity = 'WorkerEthnicity',
  workerPrimaryLanguage = 'WorkerPrimaryLanguage',
  workerVeteranStatus = 'WorkerVeteranStatus',
  workerAllergies = 'WorkerAllergies',
  workerLastSSN = 'WorkerLastSSN',
  workerGovtIdType = 'WorkerGovernmentIDType',
  workerGovtIdIssuedBy = 'WorkerGovernmentIDIssuedBy',
  workerGovtIdNumber = 'WorkerGovernmentIDNumber',
  workerGovtIdImage = 'WorkerGovernmentIDImage',
  workerRole = 'WorkerRole',
  workerLaborUnionStatus = 'WorkerLaborUnionStatus',
  workerLaborUnionNumber = 'WorkerLaborUnionNumber',
  workerTrades = 'WorkerTrades',
  workerWorkExperience = 'WorkerWorkExperience',
}

export interface IProfileFieldConstraintsMap extends Partial<Record<WorkerProfileField, IProfileFieldConstraints>> {}
